import { useTranslation } from '../../../../../../../../../hooks';
import { UserPaymentDetailsFormContentUserKycCardStatusProps } from './props';
import styles from './styles.module.scss';

/**
 * UserPaymentDetailsFormContentUserKycCardStatus Component
 * This component is responsible for displaying the status of the user's KYC (Know Your Customer) card.
 * It handles the loading state and displays the appropriate status message.
 *
 * @param {UserPaymentDetailsFormContentUserKycCardStatusProps} props - The properties for the component.
 * @param {KYCStatus} props.status - The current KYC status of the user.
 * @param {boolean} [props.isLoading] - Flag indicating whether the data is still loading.
 *
 * @returns {JSX.Element} The rendered component displaying the KYC status or a loading skeleton.
 *
 * @example
 * // Usage example:
 * <UserPaymentDetailsFormContentUserKycCardStatus status={KYCStatus.PENDING} isLoading={false} />
 */
export default function UserPaymentDetailsFormContentUserKycCardStatus({
  status,
  isLoading,
}: UserPaymentDetailsFormContentUserKycCardStatusProps) {
  const { t } = useTranslation('common');

  // Render a loading skeleton if the data is still loading
  if (isLoading) {
    return <div className={`${styles.container} skeleton--secondary`} />;
  }

  // Render the KYC status message
  return (
    <div className={`${styles.container} ${styles[`container--${status}`]}`}>
      {t(`kyc_status_${status}`)}
    </div>
  );
}
